import axios from "axios";
import {EMPTY_USER_STORE} from "../_types";
import jwtDecode from "jwt-decode";

const api = axios.create({
    baseURL: process.env.REACT_APP_SPRING_BOOT,
});

export const setupInterceptors = (store, navigate) => {
    api.interceptors.request.use((config) => {
        const user = store.getState().userReducer?.user;
        const token = user?.token;

        if (token) {
            const decoded = jwtDecode(token);
            const now = Date.now() / 1000;

            if (decoded.exp < now) {
                localStorage.removeItem('userReducer');
                navigate('/');
                store.dispatch({type: EMPTY_USER_STORE});
                return Promise.reject("Token expiré");
            }

            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });

    api.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                localStorage.removeItem('userReducer');
                navigate('/');
                store.dispatch({type: EMPTY_USER_STORE});
            }
            return Promise.reject(error);
        }
    );
}



export default api;